<script setup lang="ts">
import { Skeleton } from '~/components/ui/skeleton';

withDefaults(defineProps<{ fullWidthButton?: boolean }>(), {
	fullWidthButton: false
});

const navigationIcons = [
	'/images/agent-profile/skeleton-chevron-left.svg',
	'/images/agent-profile/skeleton-chevron-right.svg'
];
</script>

<template>
	<div
		class="mt-6 flex min-h-[104px] w-full flex-col-reverse items-start justify-between gap-6 md:min-h-12 md:flex-row md:items-center"
		aria-hidden="true"
	>
		<Skeleton
			is-active
			variant="white"
			:class="[
				'h-12 shrink-0 rounded-none motion-reduce:animate-none md:w-[148px]',
				fullWidthButton ? 'w-full' : 'w-[148px]'
			]"
		/>
		<div
			class="flex h-8 w-full items-center justify-end gap-5 md:max-w-[508px]"
		>
			<div class="flex w-full max-w-[420px] gap-3">
				<div
					v-for="index in 6"
					:key="index"
					class="h-0.5 min-w-0 flex-1 bg-white-dark-3"
				/>
			</div>
			<div class="flex shrink-0 gap-1">
				<img
					v-for="src in navigationIcons"
					:key="src"
					:src="src"
					width="32"
					height="32"
					alt=""
				/>
			</div>
		</div>
	</div>
</template>
